import React from 'react';

type Props = {
  url: string | null;
  children: (prop: boolean) => React.ReactNode;
};

type State = {
  isImageLinkBroken: boolean;
};

export class BrokenImageLinkTest extends React.Component<Props, State> {
  state: State = {
    isImageLinkBroken: false,
  };

  componentDidMount() {
    if (this.props.url) {
      const img = new Image();
      img.src = this.props.url;
      img.onerror = () => this.setState({ isImageLinkBroken: true });
    }
  }

  render() {
    return this.props.children(this.state.isImageLinkBroken);
  }
}
